// extracted by mini-css-extract-plugin
module.exports = {"hotelier_options_rooms__icon_single_bed":"singleBed_hotelier_options_rooms__icon_single_bed__3VCd-"};